var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTakkSmilefjes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 0C20.1709 0 0 20.171 0 45C0 69.8291 20.1709 90 45 90C69.8291 90 90 69.8291 90 45C90 20.171 69.8291 0 45 0ZM45 4C67.6673 4 86 22.3328 86 45C86 67.6673 67.6673 86 45 86C22.3327 86 4 67.6673 4 45C4 22.3328 22.3327 4 45 4ZM28 26C24.6862 26 22 28.6863 22 32C22 35.3137 24.6862 38 28 38C31.3137 38 34 35.3137 34 32C34 28.6863 31.3137 26 28 26ZM62 26C58.6863 26 56 28.6863 56 32C56 35.3137 58.6863 38 62 38C65.3138 38 68 35.3137 68 32C68 28.6863 65.3138 26 62 26ZM66.9688 54.8437C66.3009 54.8857 65.6667 55.2887 65.3438 55.875C60.8404 62.611 53.4158 67 45 67C36.5842 67 29.1596 62.611 24.6562 55.875C24.2603 55.2615 23.5079 54.8978 22.7812 54.9687C21.4087 55.113 20.5602 56.9577 21.3438 58.0937C26.5342 65.8583 35.194 71 45 71C54.806 71 63.4658 65.8583 68.6562 58.0937C69.5915 56.2795 68.5487 54.9164 66.9688 54.8437Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakkSmilefjes);
export default __webpack_public_path__ + "static/media/takkSmilefjes.af0e31b50bc56366d6e0c260a8e97bec.svg";
export { ForwardRef as ReactComponent };